import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private readonly http=inject(HttpClient)

  createContact(data:object):Observable<any>{
    return this.http.post(environment.baseUrl+`contact/create/`,data)
  }

}
